import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

import { useAuthStore } from "@/state/authStore";

/**
 * Guarda de rota administrativa (F1.21).
 *
 * Vive dentro do ProtectedRoute: quando chega aqui a sessão já foi validada, e
 * o que resta é o perfil. Não-admin cai no File Manager em vez de ver uma tela
 * que o backend responderia com 403 — a barreira real é a dependência
 * `get_current_admin_actor` no servidor; esta é só a versão visível dela.
 */
export function AdminRoute({ children }: PropsWithChildren) {
  const isAdmin = useAuthStore((state) => state.user?.is_admin === true);

  if (!isAdmin) {
    return <Navigate to="/manager" replace />;
  }

  return <>{children}</>;
}
